import type { AiCapabilityPage } from "../schema.js";
import { LIVE, OWNER_ONLY } from "./_shared.js";

/**
 * `GRP-OWNERSHIP` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/settings` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (hành động KHÔNG-ĐẢO ⇒ deep-link (CLAUDE.md §4)).
 */
export const GRP_OWNERSHIP = {
  id: "GRP-OWNERSHIP",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: OWNER_ONLY,
  flags: [],
  slots: [],
  llm: {
    description:
      "Trao quyền CHỦ NHÓM cho một người khác trong nhóm — 'đổi chủ nhóm', 'sang tên nhóm', 'nhường nhóm', 'bàn giao nhóm' đều là việc này. Đổi NGƯỜI đứng đầu nhóm thì ở đây; đổi TÊN GỌI của nhóm thì không (đó là GRP-EDIT-INFO), và đổi SỐ TÀI KHOẢN nhận tiền cũng không (đó là GRP-BANK-QR).",
    examples: [
      "chuyển quyền chủ nhóm",
      "chuyen quyen chu nhom",
      "nhường nhóm cho người khác",
      "nhuong nhom cho nguoi khac",
      "đổi chủ nhóm",
      // ——— 0105: thêm cho đủ 40 ———
      "doi chu nhom",
      "tôi muốn giao lại nhóm cho người khác",
      "toi muon giao lai nhom cho nguoi khac",
      "chuyển chủ nhóm cho Lan",
      "chuyen chu nhom cho Lan",
      "cho Minh làm chủ nhóm thay tôi",
      "cho Minh lam chu nhom thay toi",
      "sang năm tôi nghỉ, muốn trao lại nhóm",
      "sang nam toi nghi muon trao lai nhom",
      "bàn giao nhóm cho phụ huynh khác",
      "ban giao nhom cho phu huynh khac",
      "chuyển quyền sở hữu nhóm",
      "chuyen quyen so huu nhom",
      "nhường quyền chủ",
      "nhuong quyen chu",
      "trao quyền chủ nhóm cho Hùng",
      "trao quyen chu nhom cho Hung",
      "chuyển quyền chủ nhóm kiểu gì?",
      "chuyen quyen chu nhom kieu gi",
      "tôi không làm chủ nhóm nữa",
      "toi khong lam chu nhom nua",
      "giao nhóm lại cho An",
      "giao nhom lai cho An",
      "đổi người làm chủ nhóm",
      "doi nguoi lam chu nhom",
      "chuyển chủ sở hữu quỹ lớp",
      "chuyen chu so huu quy lop",
      "ai làm chủ nhóm thay tôi được không",
      "ai lam chu nhom thay toi duoc khong",
      "thôi làm chủ nhóm, chuyển cho Bình",
      "thoi lam chu nhom chuyen cho Binh",
      "trao lại nhóm",
      "trao lai nhom",
      "sang tên nhóm cho người khác",
      "sang ten nhom cho nguoi khac",
    ],
  },
  screen: "/groups/:groupId/settings",
  screenShows: "ownership_transfer",
  endpoints: [
    "POST /groups/{groupId}/ownership/transfer",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở cài đặt nhóm nhé. Chuyển quyền chủ là việc một chiều — chuyển xong bạn không tự lấy lại được, phải nhờ chủ mới.",
  },
  journey: { after: ["GRP-MEMBER-ROLE"] },
  help: { title: "Chuyển quyền chủ nhóm", tryNow: "chuyển quyền chủ nhóm" },
} satisfies AiCapabilityPage;
